/* eslint-disable no-console */
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useNavigate, useLocation } from "react-router-dom";
import { withNavigate } from "../authentication/pages/navigateWrapper";
import Navbar from "../../shared/components/navbar";
import Sidebar from "../../shared/components/sidebar";
import { Product } from "../../shared/interfaces/model/product.interface";
import {
  PaidProductDetails,
  Tenant,
  TenantUserData,
} from "../../shared/interfaces/model/tenant.interface";
import { getTenantDetail } from "../../store/tenant/api";
import { JWT_TYPE, getJWTDecoded } from "../../../utils/userUtils";
import MainLayout from "../../shared/components/MainLayout";

let nexbotProduct: Product = {
  id: "string",
  name: "Nexbot",
  desc: "Basic",
  appUrl: "appUrl",
  appCode: "lemmughvsxbfl3vnsxo",
  created_at: new Date(),
  price: 10.99,
};

let nexcodeProduct: Product = {
  id: "string",
  name: "nexcode",
  desc: "Basic",
  appUrl: "appUrl",
  appCode: "4x21jZmnA0TNzZfA3i3l",
  created_at: new Date(),
  price: 10.99,
};

let nexbotPaidProductDetails: PaidProductDetails = {
  productAppCode: "lemmughvsxbfl3vnsxo",
  expireDate: new Date().toString(),
};

let nexcodePaidProductDetails: PaidProductDetails = {
  productAppCode: "4x21jZmnA0TNzZfA3i3l",
  expireDate: new Date().toString(),
};

const ProductPage = () => {
  const navigate = useNavigate();
  const [products, setProducts] = useState<any[]>([]);
  const [isNexbotPurchased, setIsNexbotPurchased] = useState(false);
  const [isNexcodePurchased, setIsNexcodePurchased] = useState(false);
  const [isTenatUser, setIsTenatUser] = useState(false);
  const [isNexbotEnable, setIsNexbotEnable] = useState(false);
  const [isNexcodeEnable, setIsNexcodeEnable] = useState(false);

  useEffect(() => {
    // Inner async function to handle the fetching
    const fetchData = async () => {
      // Recupera il token dal localStorage e analizza il suo contenuto
      const token = localStorage.getItem("token");
      const userEmail = localStorage.getItem("userEmail");
      window.localStorage.setItem("isTenantUser", "false");
      let tenantUserData: TenantUserData;
      if (token) {
        try {
          const decodedToken = getJWTDecoded(token);
          // Await the tenant details since it's a Promise
          const tenant: Tenant = await getTenantDetail(
            decodedToken.firebase?.tenant || ""
          );
          if (userEmail) {
            tenant.tenantUserData?.forEach((userData: TenantUserData) => {
              if (userEmail === userData.userEmail) {
                setIsTenatUser(true);
                window.localStorage.setItem("isTenantUser", "true");
                tenantUserData = userData;
                tenantUserData.testProducts.forEach((product: any) => {
                  if (product === "Nexbot") {
                    setIsNexbotEnable(true);
                  } else if (product === "Nexcode") {
                    setIsNexcodeEnable(true);
                  }
                });
              }
            });
          }
          const parsedToken = JSON.parse(atob(token.split(".")[1])); // Decodifica il payload del token JWT
          const { availableProducts } = parsedToken;

          // Verifica se il prodotto Nexbot o Nexcode è stato acquistato
          if (availableProducts) {
            // Controlla se Nexbot è acquistato e la sua `expireDate` è futura
            nexbotProduct = availableProducts.find(
              (product: any) => product.productAppCode === "lemmughvsxbfl3vnsxo"
            );
            if (nexbotProduct && nexbotProduct.expireDate) {
              const expireDate = new Date(nexbotProduct.expireDate);
              if (
                !Number.isNaN(expireDate.getTime()) &&
                expireDate > new Date()
              ) {
                setIsNexbotPurchased(true);
                nexbotProduct.name = "Nexbot";
                nexbotProduct.appUrl = "https://nexbot-ai.com/";
                nexbotProduct.desc = "Nexbot";
                // Example of accessing the paid product details
                nexbotPaidProductDetails =
                  tenant.testProducts?.find(
                    (p) => p.productAppCode === "lemmughvsxbfl3vnsxo"
                  ) || {};
                // Do something with nexbotPaidProductDetails if needed
                if (nexbotPaidProductDetails.tier === "Basic") {
                  nexbotProduct.price = 10.99;
                } else if (nexbotPaidProductDetails.tier === "Pro") {
                  nexbotProduct.price = 19.99;
                } else {
                  nexbotProduct.price = 50.99;
                }
              }
            }

            // Controlla se Nexcode è acquistato e la sua `expireDate` è futura
            nexcodeProduct = availableProducts.find(
              (product: any) =>
                product.productAppCode === "4x21jZmnA0TNzZfA3i3l"
            );
            if (nexcodeProduct && nexcodeProduct.expireDate) {
              const expireDate = new Date(nexcodeProduct.expireDate);
              if (
                !Number.isNaN(expireDate.getTime()) &&
                expireDate > new Date()
              ) {
                setIsNexcodePurchased(true);
                nexcodeProduct.name = "Nexcode";
                nexcodeProduct.appUrl =
                  "http://dialogflowappserver.nexum.srl:4000/";
                nexcodeProduct.desc = "Nexcode";
                nexcodePaidProductDetails =
                  tenant.testProducts?.find(
                    (p) => p.productAppCode === "4x21jZmnA0TNzZfA3i3l"
                  ) || {};
                // Do something with nexcodePaidProductDetails if needed
                if (nexbotPaidProductDetails.tier === "Basic") {
                  nexcodeProduct.price = 15.0;
                } else if (nexbotPaidProductDetails.tier === "Pro") {
                  nexcodeProduct.price = 29.99;
                } else {
                  nexcodeProduct.price = 50.0;
                }
              }
            }
          }
        } catch (error) {
          console.error("Errore nel parsing del token:", error);
        }
      }
    };

    fetchData(); // Call the inner async function
  }, []);

  const handlePurchaseClickNexbot = () => {
    if (isNexbotPurchased) {
      navigate(`/detailProduct/lemmughvsxbfl3vnsxo`, {
        state: {
          product: nexbotProduct,
          paidProductInfo: nexbotPaidProductDetails,
        },
      });
    } else if (!isNexbotPurchased && isTenatUser && isNexbotEnable) {
      window.location.href = "https://nexbot-ai.com/";
    } else {
      navigate("/detailsProductV2Nexbot");
    }
  };

  const handlePurchaseClickNexcode = () => {
    if (isNexcodePurchased) {
      navigate(`/detailProduct/4x21jZmnA0TNzZfA3i3l`, {
        state: {
          product: nexcodeProduct,
          paidProductInfo: nexcodePaidProductDetails,
        },
      });
    } else if (!isNexcodePurchased && isTenatUser && isNexcodeEnable) {
      window.location.href = "https://nexbot-ai.com/";
    } else {
      navigate("/detailsProductV2Nexcode");
    }
  };

  const handleUpgrade = (tierBought: any, product: any) => {
    navigate("/private/upgradeTier", {
      state: { tierBought, product },
    });
  };

  return (
    <MainLayout>
      <TitlePage>Prodotti </TitlePage>
      <Container>
        <ProductCard>
          <Title>Nexbot</Title>
          {isNexbotPurchased && (
            <PurchasedBox>Prodotto acquistato</PurchasedBox>
          )}
          {isNexbotPurchased &&
            (nexbotPaidProductDetails.tier === "Basic" ||
              nexbotPaidProductDetails.tier === "Pro") && (
              <PurchaseButton
                onClick={() =>
                  handleUpgrade(nexbotPaidProductDetails.tier, "Nexbot")
                }
              >
                Esegui l'upgrade
              </PurchaseButton>
            )}
          {!isNexbotPurchased && isTenatUser && isNexbotEnable && (
            <EnabledBox>Prodotto abilitato</EnabledBox>
          )}
          <DescriptionBox>
            <Description>
              Nexbot è un assistente cognitivo che aiuta un utente a progettare
              l'architettura per un'infrastruttura ospitata in uno scenario
              Cloud. È in grado di progettare diagrammi sia per Google Cloud,
              AWS e Azure, e può anche combinare i servizi dei diversi fornitori
              per generare soluzioni ibride. Mentre esegue la richiesta
              dell'utente con un diagramma, analizza anche l'output stesso alla
              ricerca di errori o miglioramenti all'infrastruttura. Una volta
              che l'utente termina la creazione del diagramma, può anche
              generare un file PDF con il costo associato all'infrastruttura e
              alcuni file Terraform per distribuire l'infrastruttura stessa.
              Nexbot può anche scansionare un progetto GCP e generare un
              diagramma basato su di esso. Ultimo ma non meno importante, Nexbot
              è anche in grado di migrare i servizi da un fornitore cloud a un
              altro (per la versione corrente, è abilitata solo la migrazione
              delle macchine virtuali)
            </Description>
          </DescriptionBox>
          <PurchaseButton onClick={() => handlePurchaseClickNexbot()}>
            {!isNexbotPurchased && isTenatUser && isNexbotEnable
              ? "Vai al prodotto"
              : "Dettagli Nexbot"}
          </PurchaseButton>
        </ProductCard>

        <ProductCard>
          <Title>Nexcode</Title>
          {isNexcodePurchased && (
            <PurchasedBox>Prodotto acquistato</PurchasedBox>
          )}
          {isNexcodePurchased &&
            (nexcodePaidProductDetails.tier === "Basic" ||
              nexcodePaidProductDetails.tier === "Pro") && (
              <PurchaseButton
                onClick={() =>
                  handleUpgrade(nexcodePaidProductDetails.tier, "Nexcode")
                }
              >
                Esegui l'upgrade
              </PurchaseButton>
            )}
          {!isNexcodePurchased && isTenatUser && isNexcodeEnable && (
            <EnabledBox>Prodotto abilitato</EnabledBox>
          )}
          <DescriptionBox>
            <Description>
              Nexcode è un assistente cognitivo che consente all'utente di:
              creare e personalizzare componenti in un'applicazione React,
              aggiungere metodi e funzionalità, modificare le librerie
              dell'applicazione semplicemente chattando con essa. Creare e
              personalizzare applicazioni SpringBoot tramite swagger o richieste
              dirette utilizzando l'assistente Contenitorizzare e distribuire
              automaticamente il microservizio o l'intera applicazione su Cloud
              Run.
            </Description>
          </DescriptionBox>
          <PurchaseButton onClick={() => handlePurchaseClickNexcode()}>
            {!isNexcodePurchased && isTenatUser && isNexcodeEnable
              ? "Vai al prodotto"
              : "Dettagli Nexcode"}
          </PurchaseButton>
        </ProductCard>
      </Container>
    </MainLayout>
  );
};

export default withNavigate(ProductPage);

// Styled Components
// const PageWrapper = styled.div`
//   display: flex;
//   min-height: 100vh;
//   background-color: #e0f7fa;
// `;

// const MainContent = styled.div`
//   display: flex;
//   flex-direction: column;
//   flex: 1;
// `;

// const Container = styled.div`
//   display: flex;
//   justify-content: center;
//   gap: 200px;
//   padding: 20px;
//   padding-top: 30px; /* Margine superiore per evitare che la navbar sovrapponga i contenuti */
//   padding-left: 100px;
//   padding-right: 100px;
//   background-color: #e0f7fa;
// `;

// Existing styles
// const ProductCard = styled.div`
//   display: flex;
//   flex-direction: column;
//   justify-content: space-between; /* Distribuisce gli elementi per allineare il bottone in fondo */
//   background: linear-gradient(to top, rgba(12, 51, 51, 0.9), rgba(100, 100, 100, 0.9)), url('your-stripe-pattern-image-url'); /* Sfondo sfumato e striato */
//   background-size: cover;
//   width: 100%;
//   max-width: 400px; /* Limita la larghezza massima dei card */
//   padding: 20px;
//   background-color: #ffffff;
//   border-radius: 8px;
//   box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
//   gap: 15px;
//   flex-grow: 1; /* Permette al card di occupare spazio aggiuntivo */
// `;

// const Title = styled.h2`
//   font-size: 3.0rem;
//   color: #ffffff;
// `;

// const TitlePage = styled.h2`
//   font-size: 3rem;
//   color: #555555;
//   text-align: center;
//   margin-bottom: 20px; /* Spazio inferiore per separare il titolo dai card */
//   padding-top: 100px;
// `;

// const DescriptionBox = styled.div`
//   padding: 10px;
//   background-color: #f0f0f0;
//   border-radius: 8px;
//   text-align: center;
//   background: linear-gradient(to top, rgba(12, 51, 51, 0.9), rgba(100, 100, 100, 0.9)), url('your-stripe-pattern-image-url');
// `;

// const Description = styled.p`
//   font-size: 1.0rem;
//   color: #ffffff;
// `;

// const PurchaseButton = styled.button`
//   padding: 10px 20px;
//   background-color: #4a90e2;
//   color: white;
//   border: none;
//   border-radius: 5px;
//   cursor: pointer;
//   font-size: 1rem;
//   transition: background-color 0.3s;

//   &:hover {
//     background-color: #45a049;
//   }
// `;

// const PurchasedBox = styled.div`
//   padding: 10px;
//   margin-bottom: 10px;
//   background-color: #dff0d8;
//   color: #3c763d;
//   border-radius: 5px;
//   text-align: center;
//   font-weight: bold;
// `;

// const EnabledBox = styled.div`
//   padding: 10px;
//   margin-bottom: 10px;
//   background-color: #d9edf7;
//   color: #31708f;
//   border-radius: 5px;
//   text-align: center;
//   font-weight: bold;
// `;

const MainContent = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

const PageWrapper = styled.div`
  display: flex;
  min-height: 100vh;
  background-color: #e0f7fa;
  flex-direction: column;

  @media (min-width: 768px) {
    flex-direction: row;
  }
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  padding: 20px;
  background-color: #e0f7fa;

  @media (min-width: 768px) {
    flex-direction: row;
    justify-content: center;
    gap: 200px;
    padding: 20px 100px;
  }
`;

const ProductCard = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: linear-gradient(
      to top,
      rgba(12, 51, 51, 0.9),
      rgba(100, 100, 100, 0.9)
    ),
    url("your-stripe-pattern-image-url");
  background-size: cover;
  width: 100%;
  max-width: 400px;
  margin-left: 200px;
  padding: 20px;
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  gap: 15px;

  @media (max-width: 768px) {
    max-width: 90%;
  }
`;
const Title = styled.h2`
  font-size: 3rem;
  color: #ffffff;
`;

const TitlePage = styled.h2`
  font-size: 2rem;
  color: #555555;
  text-align: center;
  margin-bottom: 20px;
  padding-top: 20px;

  @media (min-width: 768px) {
    font-size: 3rem;
    padding-top: 100px;
  }
`;

const DescriptionBox = styled.div`
  padding: 10px;
  background-color: #f0f0f0;
  border-radius: 8px;
  text-align: center;
  background: linear-gradient(
      to top,
      rgba(12, 51, 51, 0.9),
      rgba(100, 100, 100, 0.9)
    ),
    url("your-stripe-pattern-image-url");

  @media (max-width: 768px) {
    font-size: 0.9rem;
  }
`;

const Description = styled.p`
  font-size: 1rem;
  color: #ffffff;
`;

const PurchaseButton = styled.button`
  padding: 10px 20px;
  background-color: #4a90e2;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 1rem;
  transition: background-color 0.3s;

  &:hover {
    background-color: #45a049;
  }
`;

const PurchasedBox = styled.div`
  padding: 10px;
  margin-bottom: 10px;
  background-color: #dff0d8;
  color: #3c763d;
  border-radius: 5px;
  text-align: center;
  font-weight: bold;
`;

const EnabledBox = styled.div`
  padding: 10px;
  margin-bottom: 10px;
  background-color: #d9edf7;
  color: #31708f;
  border-radius: 5px;
  text-align: center;
  font-weight: bold;
`;
